import { trans as transFn } from '@spotahome/soyuz/client';

const getStructuredFaq = faqs => {
  if (!faqs.length) {
    return null; // No faqs given
  }

  const content = faqs.map(faq => ({
    '@type': 'Question',
    name: faq.top,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.content
    }
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: content
  };
};

const getTenantFaqKeys = withGracePeriod => [
  {
    top: 'home.tenant.FAQ-section.first-item.title',
    content: withGracePeriod
      ? 'home.tenant.FAQ-section.first-item.content-with-grace-period'
      : 'home.tenant.FAQ-section.first-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.second-item.title',
    content: 'home.tenant.FAQ-section.second-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.third-item.title',
    content: 'home.tenant.FAQ-section.third-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.fourth-item.title',
    content: 'home.tenant.FAQ-section.fourth-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.fifth-item.title',
    content: 'home.tenant.FAQ-section.fifth-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.sixth-item.title',
    content: 'home.tenant.FAQ-section.sixth-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.seventh-item.title',
    content: 'home.tenant.FAQ-section.seventh-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.eighth-item.title',
    content: 'home.tenant.FAQ-section.eighth-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.ninth-item.title',
    content: 'home.tenant.FAQ-section.ninth-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.tenth-item.title',
    content: 'home.tenant.FAQ-section.tenth-item.content'
  },
  {
    top: 'home.tenant.FAQ-section.eleventh-item.title',
    content: 'home.tenant.FAQ-section.eleventh-item.content'
  }
];

export const getTenantFaq = (withGracePeriod = false) =>
  getTenantFaqKeys(withGracePeriod)
    .map(faq => ({
      top: transFn(faq.top),
      content: transFn(faq.content)
    }))
    .filter(Boolean);

export const getTenantStructuredFaq = (trans, withGracePeriod = false) => {
  const faqs = getTenantFaqKeys(withGracePeriod)
    .map(faq => ({
      top: trans(faq.top),
      content: trans(faq.content)
    }))
    .filter(Boolean);

  return getStructuredFaq(faqs);
};

export default {
  getTenantFaq,
  getTenantStructuredFaq
};
